import AppState from '../../interfaces/app-state';

export const selectProductItems = (state: AppState) => state.product.items;
export const selectProductCategories = (state: AppState) => state.product.categories;
